import {useEffect, useState} from "react";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../components/template/architecture";
import {AuthRedirectSignup, PostJSON} from "../../components/api/webservice";
import {Apis} from "../../components/api/url";
import {ThinArrowLeft, ThinLogoutIcon} from "../../components/icons/material-icons";
import ClickOutsideDetector from "../../components/clickOutside/click-outside";
import {Link, useParams} from "react-router-dom";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../components/techaran/money";

export const SignupInvoiceScreen = () => {
    const {invoiceNd} = useParams();
    const [data, setData] = useState({
        loaded: false,
        name: '',
        price: 0,
        isPaid: false,
        paidAt: '2000-01-01 00:00:00',
        createdAt: '2000-01-01 00:00:00',
        pay: '',
        trace: '',
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/signup/invoice/get',
            {
                nd: invoiceNd,
            },
            true,
            (d: {
                result: string,
                reason: string,
                name: string,
                price: number,
                isPaid: boolean,
                paidAt: string,
                createdAt: string,
                pay: string,
                trace: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectSignup();
                    return;
                }
                setData({
                    loaded: true,
                    name: d.name,
                    price: d.price,
                    isPaid: d.isPaid,
                    paidAt: d.paidAt,
                    createdAt: d.createdAt,
                    pay: d.pay,
                    trace: d.trace,
                });
            },
            () => {
            },
            AuthRedirectSignup,
            'signup',
        ).then(void 0);
    };
    useEffect(() => {
        document.title = 'پیش‌پرداخت | ثبت‌نام | نهال';
        HideMainLoading();
        fetchData();
    }, []);
    const [menuOpen, setMenuOpen] = useState(false);
    const logout = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/signup/signout',
            {},
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectSignup();
                    return;
                }
                AuthRedirectSignup();
            },
            () => {
            },
            AuthRedirectSignup,
            'signup',
        ).then(void 0);
    };
    return (
        <>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="signup-card">
                                    <div className="signup-card-header">
                                        <b>
                                            <Link to={"/"} style={{backgroundImage: 'url(/logo.png)'}}/>
                                            <span>فاکتور پیش‌پرداخت</span>
                                        </b>
                                        <div className={"signup-menu" + (menuOpen ? ' active' : '')}>
                                            <button
                                                style={{backgroundImage: `url(https://techara-images.ir/u/default.png)`}}
                                                onClick={() => setMenuOpen(v => !v)}
                                            />
                                            <ClickOutsideDetector onClickOutside={() => setMenuOpen(false)}>
                                                <div>
                                                    <i style={{backgroundImage: `url(https://techara-images.ir/u/default.png)`}}/>
                                                    <span>{data.name}</span>
                                                </div>
                                                <hr/>
                                                <button onClick={logout}>
                                                    <ThinLogoutIcon/>
                                                    <span>خروج از حساب</span>
                                                </button>
                                            </ClickOutsideDetector>
                                        </div>
                                    </div>
                                    <div className="signup-status">
                                        <b>فاکتور پیش‌پرداخت</b>
                                    </div>
                                    <div className="signup-field">
                                        <b>کد فاکتور:</b>
                                        <span>{invoiceNd?.toUpperCase()}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>وضعیت فاکتور:</b>
                                        <span>{data.isPaid ? 'پرداخت شده' : 'پرداخت نشده'}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>کد رهگیری:</b>
                                        <span>{StringDigitsConvertToPersian(data.trace)}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>مبلغ فاکتور:</b>
                                        <span>{CurrencyFormat(data.price)} تومان</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>دانش‌آموز:</b>
                                        <span>{data.name}</span>
                                    </div>
                                    <div className="signup-field">
                                        <b>شیوه پرداخت:</b>
                                        <span>آنلاین</span>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{marginTop: 20}}>
                                        <Link to={data.pay} className="btn-pay">
                                            <b>پرداخت آنلاین</b>
                                            <ThinArrowLeft/>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};